import React, { useState, useEffect } from "react";
import YoutubeTrailer from "./YoutubeTrailer";

const TrailerPlayer = ({ movies = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    console.log("🎬 Received movies in TrailerPlayer:", movies);
  }, [movies]);

  const hasMovies = movies.length > 0;

  const nextTrailer = () => {
    if (currentIndex < movies.length - 1) {
      console.log("➡️ Switching to next trailer...");
      setCurrentIndex(currentIndex + 1);
    }
  };

  return (
    <div>
      {/* ✅ Movie List (Inline & Gray Out Non-Playing Movies) */}
      {hasMovies && (
        <p className="movie-list-text">
          {movies.map((movie, index) => (
            <React.Fragment key={index}>
              <span
                className={`movie-name ${
                  index === currentIndex ? "active-movie" : "inactive-movie"
                }`}
              >
                {movie}
              </span>
              {index !== movies.length - 1 && (
                <span className="separator"> | </span>
              )}
            </React.Fragment>
          ))}
        </p>
      )}

      {/* ✅ Show Trailer */}
      {hasMovies ? (
        <YoutubeTrailer
          movieTitle={movies[currentIndex]}
          onVideoEnd={nextTrailer}
          onNextClick={nextTrailer}
        />
      ) : (
        <p>No trailers available.</p>
      )}
    </div>
  );
};

export default TrailerPlayer;
